// 标准时间转换
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export function getAngleTool(p1, p2) {
  let w1 = toRadians(p1.latitude)
  let j1 = toRadians(p1.longitude)
  let w2 = toRadians(p2.latitude)
  let j2 = toRadians(p2.longitude)
  // let ag = 0;
  // if(j1 === j2) {
  //   if(w1 > w2) {
  //     ag = 270
  //   }else if(w1 < w2) {
  //     ag = 90
  //   }else {
  //     ag = 0
  //   }
  // }
  let ag = 4 * Math.pow(Math.sin((w1 - w2) / 2), 2) - Math.pow(Math.sin((j1 - j2) / 2) * (Math.cos(w1) - Math.cos(w2)), 2);
  ag = Math.sqrt(ag);
  let temp = (Math.sin(Math.abs(j1 - j2) / 2) * (Math.cos(w1) + Math.cos(w2)));
  ag = ag / temp;
  ag = toDegrees(Math.atan(ag));
  if (j1 > j2) {
    if (w1 > w2) {
      ag = 270 - ag;
    } else {
      ag = 270 + ag;
    }
  } else {
    if (w1 > w2) {
      ag = 90 + ag;
    } else {
      ag = 90 - ag;
    }
  }
  return ag;
}
function toRadians(angdeg) {
  return angdeg / 180.0 * Math.PI;
}
function toDegrees(angrad) {
  return angrad * 180.0 / Math.PI;
}
/**
 * [binary 十进制转二级制计算]
 * @param  {[type]} num  [代表十进制数值]
 * @param  {[type]} bits [代表想转为多少位的二进制数]
 * @return {[type]} resArry    [返回的二进制数值]
 */
export function binary(num, bits) {
  var d = parseInt(parseInt(num) / 2);
  var resArry = [num % 2];
  while (d > 0) {
    resArry.push(d % 2);
    d = parseInt(d / 2);
  }
  if (bits) {
    for (var r = resArry.length; r < bits; r++) {
      // resArry.unshift(0);
      resArry.push(0);
    }
  }
  // return resArry.join().replace(/,/g, '');
  return resArry;
}
/**
 * 地图画场地相关通用方法
 * */
export const DrawFiled = {
  pixelFactor: {//半径项米计算
    10: 1 / 10,
    11: 1 / 9,
    12: 1 / 8,
    13: 1 / 7,
    14: 1 / 5,
    15: 1 / 4.773,
    16: 1 / 2.387,
    17: 1 / 1.193,
    18: 1 / 0.596,
    19: 1 / 0.298,
    20: 0.074,
    21: 0.037,
  },
  pixelWeight: {//宽度计算
    17: 5,
    18: 11,
    19: 22,
    20: 45,
    21: 90,
    22: 180,
  },
  getDistance: function (c1, c2) {//计算两个经纬度的距离
    const EARTH_RADIUS = 6378137; //地球半径,单位米
    let a1 = this.rad(c1[1]);
    let a2 = this.rad(c1[0]);
    let b1 = this.rad(c2[1]);
    let b2 = this.rad(c2[0]);
    // let b = this.rad(c2[0])-this.rad(c1[0]);
    // let a = this.rad(c2[1])-this.rad(c1[1]);
    let cosa1 = Math.cos(a1);
    let cosb1 = Math.cos(b1);
    let t1 = cosa1 * Math.cos(a2) * cosb1 * Math.cos(b2);
    let t2 = cosa1 * Math.sin(a2) * cosb1 * Math.sin(b2);
    let t3 = Math.sin(a1) * Math.sin(b1);
    let tt = Math.acos(t1 + t2 + t3);
    tt = tt * EARTH_RADIUS;
    return tt;
  },
  rad: function (d) {
    return d * Math.PI / 180
  },
  metersToPixelsAtMaxZoom: function (meters, latitude, zoom) {//根据米获得像素
    return meters / this.pixelFactor[zoom] / Math.cos(latitude * Math.PI / 180);
  },
  meterGetBorderWeight: function (zoom) {
    if (Number(zoom) < 17) {
      return 0;
    } else {
      return this.pixelWeight[zoom]
    }
  },
  drawMistakeBox(mistakePoint, c1, c2, p3, R, radius) {
    const EARTH_RADIUS = 6378137; //地球半径,单位米
    const distance1 = this.getDistance([mistakePoint.lon, mistakePoint.lat], [c1.lon, c1.lat]);
    const distance2 = this.getDistance([mistakePoint.lon, mistakePoint.lat], [c2.lon, c2.lat]);
    if (distance1 > (R + radius) && distance2 > (R + radius)) {
      let res_point = mistakePoint;
      let res_angel = this.bearing({ latitude: p3.lat, longitude: p3.lon }, { latitude: res_point.lat, longitude: res_point.lon });
      return { point: res_point, angel: res_angel }
    }
    const center = distance1 < distance2 ? c1 : c2;
    let angel = this.angleOflocation(
      { lat: mistakePoint.lat, lng: mistakePoint.lon },
      { lat: p3.lat, lng: p3.lon },
      { lat: center.lat, lng: center.lon }
    ) * Math.PI / 180;
    //计算错误点跟p3的距离
    let misPoint_p3 = this.getDistance([mistakePoint.lon, mistakePoint.lat], [p3.lon, p3.lat]);
    //计算p3和c的延长距离
    let d_p3_c = Math.cos(angel) * misPoint_p3 - R;
    let sub_point = this.caculateLatLng([p3.lat, p3.lon], [center.lat, center.lon], d_p3_c);
    //计算打点的延长距离
    let d_MistakeBox = R - this.getDistance([sub_point.lon, sub_point.lat], [mistakePoint.lon, mistakePoint.lat]) + radius + 1;

    //计算最终点
    //计算c1c2跟真北方向夹角
    let angel_c1c2_n = 0;
    if (distance1 < distance2) {
      angel_c1c2_n = this.bearing({ latitude: c2.lat, longitude: c2.lon }, { latitude: c1.lat, longitude: c1.lon });
    } else {
      angel_c1c2_n = this.bearing({ latitude: c1.lat, longitude: c1.lon }, { latitude: c2.lat, longitude: c2.lon });
    }
    //计算p3 mistakePoint跟真北方向夹角
    let angel_p3_m = this.bearing({ latitude: p3.lat, longitude: p3.lon }, { latitude: mistakePoint.lat, longitude: mistakePoint.lon });
    //7-13
    let dev_angel_p3_m = 450 - angel_c1c2_n;
    if (dev_angel_p3_m > 360) {
      dev_angel_p3_m -= 360
    }
    if (angel_p3_m + dev_angel_p3_m > 360) {
      dev_angel_p3_m -= 360
    }
    angel_p3_m += dev_angel_p3_m;
    let real_angel = 0;
    if (angel_p3_m > 90) {
      real_angel = angel_c1c2_n + 90;
    } else {
      real_angel = angel_c1c2_n - 90;
    }
    if (real_angel < 0) {
      real_angel += 360
    } else if (real_angel >= 360) {
      real_angel -= 360
    }
    real_angel = real_angel * Math.PI / 180;
    let lon = mistakePoint.lon + (d_MistakeBox) * Math.sin(real_angel) / [EARTH_RADIUS * Math.cos(mistakePoint.lat) * Math.PI / 180];
    let lat = mistakePoint.lat + d_MistakeBox * Math.cos(real_angel) / (EARTH_RADIUS * Math.PI / 180);

    let res_point = { lat: lat, lon: lon };
    let res_angel = this.bearing({ latitude: p3.lat, longitude: p3.lon }, { latitude: res_point.lat, longitude: res_point.lon });
    return { point: res_point, angel: res_angel }
  },
  // 平面坐标转换经纬度
  webMercator2LngLat(x, y) {
    var lng = (x / 20037508.34) * 180;
    var lat = (y / 20037508.34) * 180;
    lat =
      (180 / Math.PI) *
      (2 * Math.atan(Math.exp((lat * Math.PI) / 180)) - Math.PI / 2);
    return [lng, lat];
  },
  // 经纬度转墨卡托平面坐标
  lngLat2WebMercator(lng, lat) {
    console.log(lng, lat)
    const earthRad = 6378137.0;
    const x = ((lng * Math.PI) / 180) * earthRad;
    const a = (lat * Math.PI) / 180;
    const y =
      (earthRad / 2) * Math.log((1.0 + Math.sin(a)) / (1.0 - Math.sin(a)));
    return [x, y];
  },
  caculateLatLng(p1, p2, d = 2.5) {
    const EARTH_RADIUS = 6378137; //地球半径,单位米
    let distance_North = EARTH_RADIUS * (p2[0] - p1[0]);
    let distance_East = EARTH_RADIUS * Math.cos(p1[0]) * (p2[1] - p1[1]);
    let bearing = Math.atan2(distance_East, distance_North) % (2 * Math.PI);
    let lon = p2[1] + d * Math.sin(bearing) / [EARTH_RADIUS * Math.cos(p2[0]) * Math.PI / 180];
    let lat = p2[0] + d * Math.cos(bearing) / (EARTH_RADIUS * Math.PI / 180);
    return { lat: lat, lon: lon }
  },
  /*
 * 计算两点对于正北方向的朝向角度 [0,360]
 * @param {*} start format:{'latitude': 30, 'longitude': 120 }
 * @param {*} end format:{'latitude': 30, 'longitude': 120 }
 */
  bearing(start, end) {
    let rad = Math.PI / 180,
      lat1 = start.latitude * rad,
      lat2 = end.latitude * rad,
      lon1 = start.longitude * rad,
      lon2 = end.longitude * rad;
    const a = Math.sin(lon2 - lon1) * Math.cos(lat2);
    const b = Math.cos(lat1) * Math.sin(lat2) -
      Math.sin(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1);
    let angle = this.radiansToDegrees(Math.atan2(a, b))
    if (angle < 0) {
      angle = 360 + angle
    }
    return angle
  },
  /*
   * 弧度转换为角度
   */
  radiansToDegrees(radians) {
    const degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
  },
  // 计算3个地理坐标点之间的夹角
  angleOflocation(l1, l2, l3) {
    let p1 = this.geo2xyz(l1);
    let p2 = this.geo2xyz(l2);
    let p3 = this.geo2xyz(l3);

    let { x: x1, y: y1, z: z1 } = p1;
    let { x: x2, y: y2, z: z2 } = p2;
    let { x: x3, y: y3, z: z3 } = p3;

    // 计算向量 P2P1 和 P2P3 的夹角 https://www.zybang.com/question/3379a30c0dd3041b3ef966803f0bf758.html
    let _P1P2 = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2 + (z2 - z1) ** 2);
    let _P2P3 = Math.sqrt((x3 - x2) ** 2 + (y3 - y2) ** 2 + (z3 - z2) ** 2);

    let P = (x1 - x2) * (x3 - x2) + (y1 - y2) * (y3 - y2) + (z1 - z2) * (z3 - z2); //P2P1*P2P3

    return (Math.acos(P / (_P1P2 * _P2P3)) / Math.PI) * 180;
  },
  // lat,lng为弧度表示的经纬度，r为地球半径，由于是算夹角，r是多少不重要
  ball2xyz(lat, lng, r = 6400) {
    return {
      x: r * Math.cos(lat) * Math.cos(lng),
      y: r * Math.cos(lat) * Math.sin(lng),
      z: r * Math.sin(lat)
    };
  },
  // https://blog.csdn.net/reborn_lee/article/details/82497577
  // 将地理经纬度转换成笛卡尔坐标系
  geo2xyz({ lat, lng }) {
    let thera = (Math.PI * lat) / 180;
    let fie = (Math.PI * lng) / 180;
    return this.ball2xyz(thera, fie);
  },
};

/**
 * 浏览器存储相关
 * */
export let cookieSet = {
  setCookie: function (cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 12 * 60 * 60 * 1000));
    let expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) == 0) { return c.substring(name.length, c.length); }
    }
    return "";
  },
  deleteCookie: function (cname) {
    let name = cname + "=";
    document.cookie = `${name};expires=Thu, 01 Jan 1970 00:00:00 GMT`
  }
};

export let testIsStop = {
  stop: false,
  setStop: function (value) {
    this.stop = value;
  },
  getStop: function () {
    return this.stop
  }
};
export let isRouterToSpcanning = {
  stop: false,
  setValue: function (value) {
    this.stop = value;
  },
  getValue: function () {
    return this.stop
  }
};
// export function IEVersion() {
//   var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
//   var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
//   var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
//   var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
//   if(isIE) {
//     return true
//     // var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
//     // reIE.test(userAgent);
//     // var fIEVersion = parseFloat(RegExp["$1"]);
//     // if(fIEVersion == 7) {
//     //   return 7;
//     // } else if(fIEVersion == 8) {
//     //   return 8;
//     // } else if(fIEVersion == 9) {
//     //   return 9;
//     // } else if(fIEVersion == 10) {
//     //   return 10;
//     // } else {
//     //   return 6;//IE版本<=7
//     // }
//   } else if(isEdge) {
//     return false
//   } else if(isIE11) {
//     return true; //IE11
//   }else{
//     return false;//不是ie浏览器
//   }
// }



// WEBPACK FOOTER //
// ./src/plugins/tool.js